
import {Component, OnDestroy, OnInit} from '@angular/core';
import { CmProAuthService } from '@app/core/services';

import { LayoutService } from '@app/core/services/layout.service';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit, OnDestroy{

  userName: string;
  constructor(
    private authService: CmProAuthService,
              private layoutService: LayoutService) {
  }
  ngOnDestroy(): void {
    this.authService.unsubscribeToLoginEvents();
  }
  ngOnInit(): void {

    this.authService.subscribeToLoginEvents((user: UsersBus) => {
      if (user) {
        this.userName = this.authService.user.username;
      }
    });

  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

}
